import { useState } from 'react';
import { redefinirPin } from '../../api/operadores.js';
import type { Operador } from '../../api/operadores.js';
import { mensagemDoErro } from '../../api/erros.js';
import { CampoTexto } from '../../componentes/Campo.js';
import { FormularioLateral } from '../../componentes/FormularioLateral.js';
import { seHouver } from '../../componentes/props.js';

type Props = {
  readonly operador: Operador;
  readonly aoFechar: () => void;
  readonly aoConcluir: (mensagem: string) => void;
};

/** Redefinição de PIN. O supervisor digita, entrega à pessoa e a tela esquece. */
export function FormularioDePin({ operador, aoFechar, aoConcluir }: Props) {
  const [pin, definirPin] = useState('');
  const [erroDoCampo, definirErroDoCampo] = useState<string | null>(null);
  const [erro, definirErro] = useState<string | null>(null);
  const [enviando, definirEnviando] = useState(false);

  function confirmar() {
    if (pin.trim() === '') {
      definirErroDoCampo('Informe o novo PIN.');
      return;
    }

    definirErroDoCampo(null);
    definirErro(null);
    definirEnviando(true);

    redefinirPin(operador.id, { pin: pin.trim() })
      .then(() => {
        aoConcluir(`PIN de ${operador.matricula} redefinido. Entregue o novo PIN à pessoa.`);
      })
      .catch((falha: unknown) => {
        definirEnviando(false);
        definirErro(mensagemDoErro(falha));
      });
  }

  return (
    <FormularioLateral
      titulo={`PIN de ${operador.matricula}`}
      subtitulo={`${operador.nome} passa a entrar no coletor com este PIN.`}
      rotuloConfirmar="Redefinir PIN"
      aoConfirmar={confirmar}
      aoFechar={aoFechar}
      enviando={enviando}
      {...seHouver('erro', erro)}
    >
      <CampoTexto
        rotulo="Novo PIN"
        valor={pin}
        aoMudar={definirPin}
        tipo="password"
        fonte="mono"
        obrigatorio
        maximoDeCaracteres={8}
        autoCompletar="off"
        ajuda="De 4 a 8 dígitos. Não use sequência nem dígito repetido."
        {...seHouver('erro', erroDoCampo)}
      />
    </FormularioLateral>
  );
}
